import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from 'ays-shared/views/Login.vue';
import List from '@/views/List.vue';
import Part from '@/views/Part.vue';
import EditPart from '@/views/EditPart.vue';
import ChangeStock from '@/views/ChangeStock.vue';
import StockHistory from '@/views/StockHistory.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  }, {
    path: '/',
    name: 'home',
    component: List,
  }, {
    path: '/part/create',
    name: 'create_part',
    component: EditPart,
  }, {
    path: '/part/:id',
    name: 'part',
    component: Part,
  }, {
    path: '/part/:id/edit',
    name: 'edit_part',
    component: EditPart,
  }, {
    path: '/part/:id/add',
    name: 'add_stock',
    component: ChangeStock,
  }, {
    path: '/part/:id/remove',
    name: 'remove_stock',
    component: ChangeStock,
  }, {
    path: '/part/:id/stock',
    name: 'stock',
    component: StockHistory,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async(to, from, next) => {
  await store.dispatch('init');

  if (to.path != '/login' && !store.state.auth.isAuthenticated) {
    return next('/login');
  }

  if (to.path != '/login' && !store.state.auth.canEditInventoryParts) {
    await store.dispatch('logout');
    return next('/login');
  }

  return next();
});

export default router;
